var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimerAppTile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0_4_Icons_MIB3 / 0_4_3_IconMaster / home / timer_app_tile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "104.738275%",
    x2: "50%",
    y2: "-11.6174435%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0A0A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#080808",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "67.2518478%",
    y1: "91.566132%",
    x2: "30.5338437%",
    y2: "19.6777344%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C8C8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0235295%",
    y1: "12.7220465%",
    x2: "51.0753641%",
    y2: "115.88871%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2251A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E0F0A",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.4205377%",
    y1: "-11.4125845%",
    x2: "51.1240146%",
    y2: "100%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B33229",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B33229",
    stopOpacity: 0,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "0_4_Icons_MIB3-/-0_4_3_IconMaster-/-home-/-timer_app_tile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SportChrono",
    transform: "translate(10.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.6372001,66.6285714 C51.5908563,72.672 43.552695,76 35,76 C26.447305,76 18.4091437,72.672 12.3627999,66.6285714 C-0.120933307,54.1508571 -0.120933307,33.8514286 12.3627999,21.3737143 C18.4091437,15.328 26.447305,12 35,12 C43.552695,12 51.5908563,15.328 57.6372001,21.3737143 C70.1209333,33.8491429 70.1209333,54.1508571 57.6372001,66.6285714 Z",
    id: "Clock---Fill",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9492215,24.1674167 L68.0886696,20.0155278 L58.8077295,10.7066944 L54.6682814,14.8585833 C49.3802022,11.2465278 43.3307445,9.26494444 37.1937721,8.88311111 L37.1937721,4.38888889 L43.757379,4.38888889 L43.757379,6.82121026e-13 L26.2544274,6.82121026e-13 L26.2544274,4.38888889 L32.8180342,4.38888889 L32.8180342,8.88311111 C24.6025863,9.39661111 16.5315378,12.7650833 10.2523539,19.0631389 C-3.4174513,32.7740278 -3.4174513,55.0059444 10.2523539,68.7168333 C17.0894444,75.5722778 26.0465798,79 35.0059032,79 C43.9652265,79 52.922362,75.5722778 59.7594525,68.7168333 C71.8408648,56.5969167 73.2257859,37.8322222 63.9492215,24.1674167 Z M56.6636179,65.6138889 C50.8788924,71.416 43.1885331,74.6111111 35.0059032,74.6111111 C26.8232733,74.6111111 19.132914,71.416 13.3481885,65.6138889 C1.40461187,53.6344167 1.40461187,34.1455556 13.3481885,22.1660833 C19.132914,16.3617778 26.8232733,13.1666667 35.0059032,13.1666667 C43.1885331,13.1666667 50.8788924,16.3617778 56.6636179,22.1660833 C68.6071945,34.1433611 68.6071945,53.6344167 56.6636179,65.6138889 Z",
    id: "Shape---Fill",
    fill: "url(#linearGradient-2)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Steps",
    transform: "translate(6.000000, 22.029437)",
    fill: "#2D2D2D"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Step---Fill",
    x: 48,
    y: 20.9705627,
    width: 10,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Step---Fill",
    x: 0,
    y: 20.9705627,
    width: 10,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Step---Fill",
    transform: "translate(29.000000, 45.970563) rotate(-90.000000) translate(-29.000000, -45.970563) ",
    x: 24,
    y: 44.9705627,
    width: 10,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Step---Fill",
    transform: "translate(45.970563, 38.941125) rotate(-315.000000) translate(-45.970563, -38.941125) ",
    x: 40.9705627,
    y: 37.9411255,
    width: 10,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Step---Fill",
    transform: "translate(12.029437, 5.000000) rotate(-315.000000) translate(-12.029437, -5.000000) ",
    x: 7.02943725,
    y: 4,
    width: 10,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Step---Fill",
    transform: "translate(45.970563, 5.000000) rotate(-45.000000) translate(-45.970563, -5.000000) ",
    x: 40.9705627,
    y: 4,
    width: 10,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Step---Fill",
    transform: "translate(12.029437, 38.941125) rotate(-45.000000) translate(-12.029437, -38.941125) ",
    x: 7.02943725,
    y: 37.9411255,
    width: 10,
    height: 2,
    rx: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.75,18.8591244 L32.75,43.5675112 C32.75,44.772245 33.758,45.75 35,45.75 C36.242,45.75 37.25,44.772245 37.25,43.5675112 L37.25,18.8591244 C36.50975,18.7892848 35.7605,18.75 35,18.75 C34.2395,18.75 33.49025,18.7892848 32.75,18.8591244 Z",
    id: "Pointer---Fill",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,19.25 C35.5898825,19.25 36.1728497,19.274181 36.75,19.3182267 L36.75,19.3182267 L36.75,43.5675112 C36.75,44.0301807 36.5551481,44.4484852 36.242622,44.751634 C35.9244967,45.060214 35.4847815,45.25 35,45.25 C34.5152185,45.25 34.0755033,45.060214 33.757378,44.751634 C33.4448519,44.4484852 33.25,44.0301807 33.25,43.5675112 L33.25,43.5675112 L33.25,19.3182267 C33.8271503,19.274181 34.4101175,19.25 35,19.25 L35,19.25 Z",
    id: "Pointer---Border",
    stroke: "url(#linearGradient-4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerAppTile);
export default __webpack_public_path__ + "static/media/timer_app_tile.18b2d0b792848af2fed5e6afc3a01bc0.svg";
export { ForwardRef as ReactComponent };